module.exports = __webpack_public_path__ + "img/6.4e69e79a.png";